module.exports = "/fonts/vendor/material-icons/iconmaterial-icons-round.woff2?121a59d703f74d7fc4a1bf64580966ed";